import { Injectable, signal, computed } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AppStateService {
  isShopifyTarget = signal<boolean>(false);

  isShopify = signal<boolean>(false);
  learningMode = signal<boolean>(false);
  autoActivate = signal<boolean>(false);
  behamicsDeactivated = signal<boolean>(false);

  targetUrl = signal<string>('');

  /**
   * The selected target's go-live dates (ISO strings, oldest first) from
   * `/targets`: the first one is when it first went live with nudges, any
   * later ones are reactivations.
   */
  goLiveDates = signal<string[]>([]);

  /**
   * Reads `goliveDates` from a `/targets` entry, falling back to the single
   * `firstLiveWithNudge` date until the backend returns the array everywhere.
   */
  setGoLiveDates(target: any) {
    const dates: string[] =
      Array.isArray(target?.goliveDates) && target.goliveDates.length
        ? target.goliveDates
        : target?.firstLiveWithNudge
          ? [target.firstLiveWithNudge]
          : [];

    this.goLiveDates.set(
      dates
        .filter((d) => d && !isNaN(new Date(d).getTime()))
        .sort((a, b) => new Date(a).getTime() - new Date(b).getTime()),
    );
  }

  /** The selected target's `ab_testing_tool` flag: the new nudge view instead of the old one. */
  abTestingView = signal<boolean>(false);

  /**
   * `abTestingView` has been set for this session's target. Until then it is
   * only the default, and the localStorage copy may be empty (logout clears
   * it) or another target's — so `/master-preview` waits for this rather than
   * load one nudge view and swap to the other a moment later.
   */
  abTestingViewKnown = signal<boolean>(false);
}
